export const MAIN_COLOR = '#2D75B8'

export const host = process.env.REACT_APP_HOST
export const tenant = process.env.REACT_APP_TENANT
export const client_id = process.env.REACT_APP_CLIENT_ID
export const extension = process.env.REACT_APP_EXTENSION
export const issuer = process.env.REACT_APP_ISSUER
export const env = process.env.REACT_APP_ENV

export const OPENID_CONNECT_FLOW = 'https://login.microsoftonline.com/' +
  tenant + '/oauth2/v2.0/authorize?' +
  'client_id=' + client_id + 
  '&response_type=id_token' + 
  '&redirect_uri=' + host + 'callback/' + 
  '&nonce=defaultNonce' +
  '&scope=openid' + 
  '&prompt=login' +
  '&response_mode=form_post'

export const CODES = [
  { code: 999, description: "An error occured"},
  { code: 100, description: "Can't get access token from MS Graph"},
  { code: 101, description: "Permission denied: your role is not allowed to perform this action"},
  { code: 102, description: "JWT not valid"},
  { code: 103, description: "Token not found"},
  { code: 104, description: "Token not valid"},
]

export const EMPLOYEE_TYPE = [
  'TA (Temporary Appointment)',
  'FTA (Full Time Appointment)',
  'PA (Permanent Appointment)',
  'SCT (Service Contract)',
  'SSA/IC (Special Service Agreement/Individual Contract)',
  'UNV (UN Volunteers)',
  'POI (Person Of Interest)'
]

export const USER_TYPE = [
  'GVT (EA Government)',
  'AGY (EA Agency)',
  'MPTF (EA MPTF Gateway)',
  'UNEX (EA MPTF UNEX)'
]

export const TOP = 30